import TalentaInsightIcon from 'Assets/Images/insight-logo-black.svg';
import { StyleLogoTalenta } from './style';

function LogoTalentaInsight() {
  return (
    <StyleLogoTalenta>
      <div className="logo">
        <img src={TalentaInsightIcon} alt="Talenta Insight" />
      </div>
    </StyleLogoTalenta>
  );
}

export default LogoTalentaInsight;
